import React, { Component } from 'react'
import zhihuHybrid from 'zhihu-hybrid'
import ImageArea from '~/components/ImageArea'
import SVG from '~/components/SVG'
import { isHybridable } from '~/utils'
import playBtn from '~/assets/btn-play.svg'
import styles from './index.css'

export default class Index extends Component {
  state = {
    isNativePlaySupported: false,
  }

  componentWillMount() {
    if (isHybridable) {
      zhihuHybrid
        .supportsAction('base/openVideo')
        .then(isNativePlaySupported => {
          this.setState({ isNativePlaySupported })
        })
    }
  }

  handleClick = e => {
    e.preventDefault()
    const { title, videoId, cover } = this.props
    zhihuHybrid.dispatch('base/openVideo', { id: videoId, title, cover })
  }

  render() {
    const { isNativePlaySupported } = this.state
    const { bannerType, title, videoUrl, cover, videoSize } = this.props

    if (bannerType === 0) {
      if (isHybridable && isNativePlaySupported) {
        return (
          <ImageArea src={cover} style={videoSize}>
            <div
              className={styles.bannerModulePlayButton}
              onClick={this.handleClick}
            >
              <SVG src={playBtn} width={60} height={60} />
            </div>
          </ImageArea>
        )
      }

      return (
        <div className={styles.bannerModule} style={videoSize}>
          <iframe title={title} frameBorder="0" src={videoUrl} />
        </div>
      )
    }

    return <ImageArea src={cover} style={videoSize} />
  }
}



// WEBPACK FOOTER //
// ./src/modules/Banner/ideaVideoBanner.js